import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["ref", "height", "width", "size", "className", "style", "children"],
  _excluded2 = ["ref", "base", "className", "style", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getSpacing } from "@faire/web--source/slate/spacing/getSpacing";
import { cn } from "@faire/web--source/tools/cn";
import React from "react";
import { isResponsiveProp } from "../Theme/ResponsiveProp";
// eslint-disable-next-line import/no-unassigned-import
import "./native-styles.css";
/**
 * @trackcomponent
 *
 * @link [Docs](https://slate.faire.team/component/spacer/web/spacer)
 */
export var Spacer = function Spacer(_ref) {
  var _ref2;
  var ref = _ref.ref,
    heightProp = _ref.height,
    widthProp = _ref.width,
    sizeProp = _ref.size,
    className = _ref.className,
    styleProp = _ref.style,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var styles = {};
  var vars = {};
  var classNames = [];
  var definedSize = (_ref2 = sizeProp !== null && sizeProp !== void 0 ? sizeProp : widthProp) !== null && _ref2 !== void 0 ? _ref2 : heightProp;
  if (definedSize != null) {
    if (isResponsiveProp(definedSize)) {
      vars["--f_spacer_size_mobile"] = getSpacing(definedSize.mobileAndAbove);
      vars["--f_spacer_size_tablet"] = definedSize.tabletAndAbove != null ? getSpacing(definedSize.tabletAndAbove) : vars["--f_spacer_size_mobile"];
      vars["--f_spacer_size_desktop"] = definedSize.desktopAndAbove != null ? getSpacing(definedSize.desktopAndAbove) : vars["--f_spacer_size_tablet"];
      vars["--f_spacer_size_xlarge"] = definedSize.xLargeAndAbove != null ? getSpacing(definedSize.xLargeAndAbove) : vars["--f_spacer_size_desktop"];
      vars["--f_spacer_size_xxlarge"] = definedSize.xxLargeDesktop != null ? getSpacing(definedSize.xxLargeDesktop) : vars["--f_spacer_size_xlarge"];
      classNames.push("f_spacer_variable_fb");
      if ((sizeProp !== null && sizeProp !== void 0 ? sizeProp : widthProp) != null) {
        classNames.push("f_spacer_variable_min_width");
      }
      if ((sizeProp !== null && sizeProp !== void 0 ? sizeProp : heightProp) != null) {
        classNames.push("f_spacer_variable_min_height");
      }
    } else {
      vars["--f_spacer_size_mobile"] = getSpacing(definedSize);
      classNames.push("f_spacer_single_value_fb");
      if ((sizeProp !== null && sizeProp !== void 0 ? sizeProp : widthProp) != null) {
        classNames.push("f_spacer_single_value_min_width");
      }
      if ((sizeProp !== null && sizeProp !== void 0 ? sizeProp : heightProp) != null) {
        classNames.push("f_spacer_single_value_min_height");
      }
    }
    styles = _objectSpread(_objectSpread({}, widthProp ? {
      height: 0
    } : {}), heightProp ? {
      width: 0
    } : {});
  }
  return /*#__PURE__*/React.createElement("div", _objectSpread({
    ref: ref,
    style: _objectSpread(_objectSpread(_objectSpread({}, vars), styles), styleProp),
    className: cn(className, "f_spacer_base", classNames)
  }, rest), children);
};
/**
 * @trackcomponent
 *
 * @link [Docs](https://slate.faire.team/component/spacer/web/growing-spacer)
 */
export var GrowingSpacer = function GrowingSpacer(_ref3) {
  var ref = _ref3.ref,
    sizeProp = _ref3.base,
    className = _ref3.className,
    styleProp = _ref3.style,
    children = _ref3.children,
    rest = _objectWithoutProperties(_ref3, _excluded2);
  var vars = {};
  var classNames = [];
  if (sizeProp != null) {
    if (isResponsiveProp(sizeProp)) {
      vars["--f_spacer_size_mobile"] = getSpacing(sizeProp.mobileAndAbove);
      vars["--f_spacer_size_tablet"] = sizeProp.tabletAndAbove != null ? getSpacing(sizeProp.tabletAndAbove) : vars["--f_spacer_size_mobile"];
      vars["--f_spacer_size_desktop"] = sizeProp.desktopAndAbove != null ? getSpacing(sizeProp.desktopAndAbove) : vars["--f_spacer_size_tablet"];
      vars["--f_spacer_size_xlarge"] = sizeProp.xLargeAndAbove != null ? getSpacing(sizeProp.xLargeAndAbove) : vars["--f_spacer_size_desktop"];
      vars["--f_spacer_size_xxlarge"] = sizeProp.xxLargeDesktop != null ? getSpacing(sizeProp.xxLargeDesktop) : vars["--f_spacer_size_xlarge"];
      classNames.push(".f_spacer_variable_fb");
    } else {
      vars["--f_spacer_size_mobile"] = getSpacing(sizeProp);
      classNames.push("f_spacer_single_value_fb");
    }
  }
  return /*#__PURE__*/React.createElement("div", _objectSpread({
    ref: ref,
    style: _objectSpread(_objectSpread({}, vars), styleProp),
    className: cn(className, "f_spacer_grow", classNames)
  }, rest), children);
};